export default __webpack_public_path__ + "static/media/VolvoNovum-Light.e4d6ae3b.woff2";